import { type FC } from 'react';
import styles from './NftPdpExhibitions.scss';
import { FormattedMessage } from 'dibs-react-intl';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel';
import { HeroBannerItem } from '../../nftExhibition/components/HeroBanner/HeroBannerItem';
import { graphql, useFragment } from 'react-relay';
import { type NftPdpExhibitions_nftItem$key } from './__generated__/NftPdpExhibitions_nftItem.graphql';
import slugify from 'dibs-slugify/exports/slugify';

const MAX_EXHIBITIONS_COUNT = 4;

type Props = {
    nftItem: NftPdpExhibitions_nftItem$key;
};

export const NftPdpExhibitions: FC<Props> = ({ nftItem: nftItemRef }) => {
    const nftItem = useFragment(
        graphql`
            fragment NftPdpExhibitions_nftItem on NftItem {
                exhibitions {
                    urlLabel
                    heroBanner {
                        ...HeroBannerItem_heroBannerItemExhibition
                    }
                }
            }
        `,
        nftItemRef
    );

    return (
        <>
            <div className={styles.mobileSeparator} />
            <section className={styles.wrapper}>
                <HeadingLevel>
                    {Header => (
                        <Header className={styles.header}>
                            <FormattedMessage
                                id="nft.pdp.exhibitions.header"
                                defaultMessage="Featured In"
                            />
                        </Header>
                    )}
                </HeadingLevel>
                <ul className={styles.grid}>
                    {nftItem.exhibitions
                        ?.slice(0, MAX_EXHIBITIONS_COUNT)
                        .map((exhibition, index) => {
                            return (
                                <li className={styles.gridItem} key={index}>
                                    <HeroBannerItem
                                        index={index}
                                        inViewport
                                        isVisible
                                        heroBannerItemExhibition={
                                            exhibition?.heroBanner?.[0] || null
                                        }
                                        isTile
                                        tileHeader={null}
                                        tileHref={`/nft-collections/exhibitions/${slugify(
                                            exhibition?.urlLabel
                                        )}`}
                                    />
                                </li>
                            );
                        })}
                </ul>
            </section>
        </>
    );
};
